'use strict';

import useSubscribeAction from "../hooks/useSubscribeAction";

export default function SearchSubscribeButton({ routes = [] }) {
    const { subscribe, currentRoutesIsSubscribed } = useSubscribeAction({ routes })

    const isRoutesComplete = routes.every(({ from, to, date, time, seats }) => {
        return from && from.id && from.type
            && to && to.id && to.type
            && !!date && !!time && !!seats
    })

    const tooltip = currentRoutesIsSubscribed ? tMsg("Вы подписаны на этот маршрут") : tMsg("Будем рассказывать про самые выгодные самолеты в этом поиске")

    if (isRoutesComplete)
        return (
            <a role='button'
                className={cn("watch-the-price el-sidebar__single", currentRoutesIsSubscribed && "active")}
                data-tooltip={tooltip}
                onClick={subscribe}
            >
                {tMsg("Следить за ценой")} <i className="icon-favorite"></i>
            </a>
        )

    return null
}
